import $ from 'jquery';

const registeredElements = new Set<HTMLElement>();
let listenerAttached = false;

const handleEscape = (event: KeyboardEvent): void => {
    if (event.key !== 'Escape') {
        return;
    }
    registeredElements.forEach((element) => {
        $(element).tooltip('hide');
    });
};

/**
 * Make Escape dismiss a Bootstrap tooltip even when the trigger element is not
 * focused (e.g. hover-only). A per-element keydown listener only fires while the
 * element has focus, so hover tooltips could not be closed with Escape (ADA).
 * keydown is composed, so the single document listener also catches events from
 * Shadow DOM (MonthlyCalendarV7).
 */
export const registerTooltipEscapeDismissal = (element: HTMLElement): void => {
    registeredElements.add(element);
    if (!listenerAttached) {
        document.addEventListener('keydown', handleEscape, true);
        listenerAttached = true;
    }
};

export const unregisterTooltipEscapeDismissal = (element: HTMLElement): void => {
    registeredElements.delete(element);
    if (registeredElements.size === 0 && listenerAttached) {
        document.removeEventListener('keydown', handleEscape, true);
        listenerAttached = false;
    }
};
